export default __webpack_public_path__ + "static/media/subcat.ec5b3b02.png";